import { render, staticRenderFns } from "./ruleAdderFec.vue?vue&type=template&id=0bc996aa&"
import script from "./ruleAdderFec.vue?vue&type=script&lang=ts&"
export * from "./ruleAdderFec.vue?vue&type=script&lang=ts&"
import style0 from "./ruleAdderFec.vue?vue&type=style&index=0&id=0bc996aa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports